module.exports = __webpack_public_path__ + "static/media/slide22.5725980c.jpg";